
import { Button, Skeleton } from '@alphorm/ui'
import Text from './text.json'
import { useState, useEffect } from 'react'
import { BASE_URL_WEB } from 'constants/'
import fetch from 'core/fetch'
import { useLocation } from 'react-router-dom'

export default ({ addingCreditCard }) => {
  const [cmiConfiguration, setCmiConfiguration] = useState(null)
  const { pathname } = useLocation()
  const setupQuery = `${BASE_URL_WEB}/Payment/creditCard/setupCmi?frontPage=${pathname}`

  useEffect(() => {
    const fetchSetup = async () => {
      const data = await fetch(setupQuery, { method: 'POST' })
      setCmiConfiguration(data)
    }
    fetchSetup()
  }, [])
  return (
    !addingCreditCard && cmiConfiguration
      ? (
        <form width='100%' name='cmiForm' method='post' action={cmiConfiguration.GatewayLink}>
          {
            cmiConfiguration.Config.map((input, key) => (
              <input key={key} type='hidden' name={input.Key} value={input.Value} />
            ))
          }
          <Button
            width='100%'
            type='submit'
            label={Text.addCardButton}
            variation='confirmation'
          />
        </form>
        )
      : <Skeleton lines={1} height={63} width='100%' />
  )
}
